interface LoadingPageProps {
  message?: string;
}

export default function LoadingPage({ message = '載入中...' }: LoadingPageProps) {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50">
      <div className="text-center">
        {/* Loading Spinner */}
        <div className="inline-block w-16 h-16 border-4 border-gray-200 border-t-line-green rounded-full animate-spin mb-4" />

        {/* Logo or App Name */}
        <h1 className="text-2xl font-bold text-gray-900 mb-2">
          我的餐車管家
        </h1>

        {/* Loading Message */}
        <p className="text-gray-600">{message}</p>
      </div>
    </div>
  );
}
